import { css } from '@emotion/react'

import { size } from '@twisto/styles'

export const list = css`
  margin: 0;
  padding: 0;
  list-style: none;
  display: flex;
  flex-direction: column;
  gap: clamp(${size[20]}, 1vw + ${size[16]}, ${size[24]});
  margin-top: clamp(${size[20]}, 1vw + ${size[16]}, ${size[32]});
`
